<div class="content">
  <div class="leading">
    <div class="avatar-container">
      <ca-badge-wrapper [permissions]="member?.permissions" [small]="true">
        <ca-avatar
          [fullName]="member | displayname"
          [image]="member?.profileImage | filedownloadurl | async"
        ></ca-avatar>
      </ca-badge-wrapper>
    </div>
  </div>
  <div class="main">
    <div class="title">
      <h2>{{ member | displayname }}</h2>
    </div>
    <div class="timestamp">
      <h4>{{ event.created | caDate : "timestamp" }}</h4>
    </div>
    <div class="subtitle">
      <memo-action-icon
        item-start
        [iconLabel]="event?.type | actionicon"
        purpose="announcement"
      ></memo-action-icon>
      {{ "announcements.actions." + event?.type | translate }}
    </div>
    @if (!!trailing) {
      <div class="trailing">{{ trailing }}</div>
    }
  </div>
</div>
